import { render, staticRenderFns } from "./DataTableSales.vue?vue&type=template&id=3f876daf&"
import script from "./DataTableSales.vue?vue&type=script&lang=js&"
export * from "./DataTableSales.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports